export  default {
    methods:{
        initPageInfo: function initPageInfo() {
            let response = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            this.$set(this, 'page', {
                list: response.records || [],
                pageNum: response.current || 0,
                pageSize: response.size || 10,
                total: response.total || 0
            });
        },
    }
}



// WEBPACK FOOTER //
// ./src/configure/warp/support/pager.js